const React = require('react');
const SharedModels = require('../../../shared/sharedModels');
const SharedConstants = require('../../../shared/sharedConstants');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('./redux/reduxStore.jsx.js');
const AjaxFunctions = require('./ajaxFunctions.js');
const graphManager = require('./graphManager.js').graphManager;
const controller = require('./controllers/connectionsViewController.js');
const ToastAlert = require('./components/toastAlert');
import Button from '@material-ui/core/Button';
import Toastr from 'toastr';

import ConnectionConjectureCreation from './components/connectionConjectureCreation';
import { Grid } from '@material-ui/core';

export class ConnectionsView extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         selectedCard: null,
         items: []
      }
   }

   componentDidMount() {
      AjaxFunctions.getIncubatorGraphData(this.props.idPortfolio).then(items => {
         items = items.filter(item => {
            return item.cardType ===  SharedConstants.CardType.Evidence
               || item.cardType ===  SharedConstants.CardType.Reasoning
         });
         this.setState({ items });
      }).catch(err => {
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error(err);
      });
   }

   render() {
      return (
         <Grid container spacing={2} >
         <Grid item lg={3}>
         <ConnectionConjectureCreation
                  cardSet={this.state.items}
                  selectedCard={this.state.selectedCard}
                  enableAdd={this.props.enableAdd}
                  headerText={this.props.headerText}
                  subHeaderText={this.props.subHeaderText}
                  linkBase={this.props.linkBase}

               />
         </Grid>
         <Grid item lg={9}>
         <MainVisCanvas
                  enableAdd={this.props.enableAdd}
                  cardSet={this.state.items}
                  setSelectedCard={(selectedCard) => this.setState({selectedCard})}
               />
         </Grid>
         </Grid>

      );
   }
}


class VisCanvas extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
        linkButtonLocation: null,
      };
      graphManager.curNetwork = null;
   }

   componentWillMount() {
      graphManager.curNetwork = null;
      graphManager.curContainer = null;
   }

   componentDidMount() {
      graphManager.curContainer = document.getElementById('VisCanvas');
      graphManager.onHighlightedNodeChange = (position) => {
         if(position) {
            let containerPosition = graphManager.curContainer.getBoundingClientRect();
            position.x += containerPosition.x;
            position.y += containerPosition.y;
         }
         this.setState({linkButtonLocation: position});
      };

      graphManager.addEdgeFunction = this.addEdgeFunction;

      if(!graphManager.curNetwork && graphManager.curNodes.length > 0){
         this.initNetwork();
      }
   }

   getCard(idCard, cardType){
      return this.props.cardSet.find(c => {
         return c.cardType === cardType && c.id === parseInt(idCard)
      });
   }

   initNetwork() {

      graphManager.initNetwork();
      if (!this.props.enableAdd) {
         graphManager.curNetwork.setOptions({ manipulation: { enabled: false } });
      }

      graphManager.curNetwork.on("selectNode", (params) => {
         this.selectNodeFunction(params.nodes[0]);
         if (!this.props.enableAdd) {
            graphManager.curNetwork.setOptions({ manipulation: { enabled: false } });
         }
      });
   }

   addEdgeFunction(idEdgeTo, idEdgeFrom){
      let edgeToCard = this.getCard(idEdgeTo.substring(1) ,1);
      let edgeFromCard = this.getCard(idEdgeFrom.substring(1) ,1);
      if(idEdgeTo.substring(0,1) === 'b' && idEdgeFrom.substring(0,1) === 'b'){

      ReduxStore.store.dispatch(ReduxStore.GreySpaceCardFunctions.addEvidenceToCreation(edgeToCard));
      ReduxStore.store.dispatch(ReduxStore.GreySpaceCardFunctions.addEvidenceToCreation(edgeFromCard));

      ReduxStore.store.dispatch(ReduxStore.GreySpaceCardFunctions.addCard(new SharedModels.GreySpaceCard({
         idGreySpaceCard: "card_placeholder",
         title: "New µPub",
         isPrivate: true,
         evidenceCard1: edgeToCard,
         evidenceCard2: edgeFromCard,
      })));

      }else{
         ToastAlert.warning('Sorry. You\'re only able to link Evidence &micro;Pubs together.', null);
      }  
   }

   selectNodeFunction(idNode){
      if(idNode.substring(0,2) === 'gn'){
         graphManager.options.manipulation.deleteNode = (data, callback) => {
            AjaxFunctions.deleteConjecture(idNode.substring(2)).then(() => {
               ReduxStore.store.dispatch(ReduxStore.GreySpaceCardFunctions.removeCard(parseInt(idNode.substring(2))));
               callback(data);
            });

         };

         this.props.setSelectedCard(this.getCard(idNode.substring(2), 2));
      }
      else if(idNode.substring(0,1) === 'g' || idNode.substring(0,1) === 'b'){
         let cardType = idNode.substring(0,1) === 'b' ? 1 : 2;

         graphManager.options.manipulation.deleteNode = false;
         this.props.setSelectedCard(this.getCard(idNode.substring(1), cardType));
      }
      else{
         graphManager.options.manipulation.deleteNode = false;
         this.props.setSelectedCard(null);
      }
      graphManager.curNetwork.setOptions(graphManager.options);
   }


   render() {
      graphManager.setNodes(this.props.nodes);
      graphManager.setEdges(this.props.edges);
      if(graphManager.curContainer && !graphManager.curNetwork && graphManager.curNodes.length > 0){
         this.initNetwork();
      }
 
      return(
         <div>
            <div id="VisCanvas">Sorry, there aren't any  &micro;Pubs to display in the graph view.</div>
           { this.props.enableAdd && 
            <Button onClick={() => graphManager.curNetwork.addEdgeMode()} variant="outlined" color="primary">
               Create Link
            </Button>}
         </div>

      )
   }
}

const mapVisCanvasViewStateToProps = (state, ownProps) => {
   let nodes = [], edges = [];
   // If no card set is passed in, default to using state.CardReducer.cardList
   let cardSet = (ownProps.cardSet)? ownProps.cardSet : state.CardReducer.cardList;
   let curSearchString = state.EditorReducer.searchString;

   let filteredEvidenceCardList = cardSet.filter(function(card){
      let creatorName = card.creator.firstName + ' ' + card.creator.lastName;
      return (card.title.toLowerCase().indexOf(curSearchString.toLowerCase()) !== -1
            || creatorName.toLowerCase().indexOf(curSearchString.toLowerCase()) !== -1) &&
            card.cardType === SharedConstants.CardType.Evidence;
   });

   for(let card of filteredEvidenceCardList){
      nodes.push( controller.createEvidenceNode(card) );
   }

   let filteredConjectureCardList = cardSet.filter(function(card){
      let creatorName = card.creator.firstName + ' ' + card.creator.lastName;
      return (card.title.toLowerCase().indexOf(curSearchString.toLowerCase()) !== -1
      || creatorName.toLowerCase().indexOf(curSearchString.toLowerCase()) !== -1)
      && card.cardType === SharedConstants.CardType.Reasoning;
   });

   for(let card of filteredConjectureCardList){
      nodes.push( controller.createReasoningNode(card) );
      let reasoningEdges = controller.createReasoningEdges(card);
      for(let e of reasoningEdges)
         edges.push(e);
   }

   let filteredGreySpaceCards = state.GreySpaceCardReducer.cardList.filter(function(card){
      let creatorName = card.creator.firstName + ' ' + card.creator.lastName;
      return (card.title.toLowerCase().indexOf(curSearchString.toLowerCase()) !== -1
      || creatorName.toLowerCase().indexOf(curSearchString.toLowerCase()) !== -1)
     
   });

   for(let card of filteredGreySpaceCards){
         nodes.push( controller.createReasoningNode(card) );
         let reasoningEdges = controller.createReasoningEdges(card);
         for(let e of reasoningEdges)
            edges.push(e);
   }

   return {
      nodes,
      edges,
   }
};

const mapVisCanvasViewDispatchToProps = (dispatch) => {
   return {
   }
};


const MainVisCanvas = connect(
   mapVisCanvasViewStateToProps,
   mapVisCanvasViewDispatchToProps
)(VisCanvas);